export default [
     {
          path: '/initiative-details/:id',
          name: 'InitiativeDetails',
          component: () => import("@/views/Page/StrategicPlan/Initiative/InitiativeDetails.vue"),
           meta: {
               title: 'InitiativeDetails',
               permission: 'Initiative.show',
          },
     }
];